import React, { createContext, useState, useEffect, useContext } from 'react';

const VillainContext = createContext();

export const VillainProvider = ({ children }) => {
  // Load villain data from localStorage on initial render
  const [villain, setVillain] = useState(() => {
    const savedVillain = localStorage.getItem('stoicVillain');
    return savedVillain ? JSON.parse(savedVillain) : {
      name: '',
      attributes: [],
      created: false
    };
  });

  // Save villain data to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('stoicVillain', JSON.stringify(villain));
  }, [villain]);

  // Add or update an attribute
  const updateAttribute = (index, value) => {
    setVillain(prev => {
      const newAttributes = [...prev.attributes];
      newAttributes[index] = value;
      return { ...prev, attributes: newAttributes };
    });
  };

  // Set the villain's name
  const setVillainName = (name) => {
    setVillain(prev => ({ ...prev, name }));
  };

  // Mark villain as created
  const createVillain = () => {
    setVillain(prev => ({ ...prev, created: true }));
  };

  // Reset villain
  const resetVillain = () => {
    setVillain({
      name: '',
      attributes: [],
      created: false
    });
  };

  return (
    <VillainContext.Provider value={{ 
      villain, 
      updateAttribute, 
      setVillainName, 
      createVillain,
      resetVillain
    }}>
      {children}
    </VillainContext.Provider>
  );
};

// Custom hook to use the villain context
export const useVillain = () => {
  const context = useContext(VillainContext);
  if (!context) {
    throw new Error('useVillain must be used within a VillainProvider');
  }
  return context;
};
